import ICsvData from "../models/ICsvData";
import { ActionType, Action } from "../actions/CsvUploaderActions";
import CsvValidation from "../models/CsvValidation";

// Define the state interface for the current reducer
export interface IState {
  csvData: ICsvData[];
  isValid: CsvValidation;
}

// Define the initial state
export const initialState: IState = {
  csvData: [],
  isValid: CsvValidation.Unknown,
};

/*
 * Reducer takes 2 arguments
 * state: The state of the reducer. By default initialState (if there was no state provided)
 * action: Action to be handled.
 */
export function reducer(state: IState = initialState, action: Action) {
  switch (action.type) {
    case ActionType.UploadCsv: {
      return {
        ...state,
        csvData: action.payload.csvData,
        isValid: action.payload.isValid,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/reducers/CsvUploaderReducer.ts